import React, { useContext, useEffect, useRef } from 'react'

import Navigation from './Navigation'
import NavBar from './NavBar'
import useWindowSize from '../../hooks/useWindowSize'
import { ConfigContext } from '../../contexts/ConfigContext'
import * as actionType from '../../store/actions'
import useAuth from '../../hooks/useAuth'
import JWTContext from '../../contexts/JWTContext'
import { getLocalStorage } from '../../utils/localStorage'

function AdminLayout({ children }) {
  const windowSize = useWindowSize()
  const ref = useRef()
  const configContext = useContext(ConfigContext)
  const { isLoggedIn } = useAuth()

  const { collapseMenu, layout, subLayout, headerFixedLayout } =
    configContext.state
  const { dispatch } = configContext
  const { menu, admin, entity, scope, client_access } = useContext(JWTContext)

  const name = getLocalStorage('entity_scope')
  const username = getLocalStorage('username')
  const appname = getLocalStorage('appname')
  const customername = getLocalStorage('customername')
  const parsedProfile = getLocalStorage('profile')
  const logo = getLocalStorage('logo')

  let profile = ''
  if (
    parsedProfile !== null &&
    typeof parsedProfile !== 'undefined' &&
    parsedProfile !== ''
  ) {
    profile = JSON.parse(parsedProfile)
  }

  useEffect(() => {
    if (
      windowSize.width > 992 &&
      windowSize.width <= 1024 &&
      layout !== 'horizontal'
    ) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }

    if (layout === 'horizontal' && windowSize.width < 992) {
      dispatch({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' })
    }
  }, [dispatch, layout, windowSize, isLoggedIn])

  const mobileOutClickHandler = () => {
    if (windowSize.width < 992 && collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }
  }

  let mainClass = ['pcoded-wrapper', 'flex-column-full']
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    mainClass = [...mainClass, 'container']
  }

  let common = (
    <>
      <Navigation menu={menu} apptitle={appname} customername={customername} />
    </>
  )

  let mainContainer = (
    <>
      <NavBar
        entity={entity}
        scope={scope}
        entity_scope_name={name}
        username={username}
        profile={profile}
        logo={logo}
        admin={admin}
        client_access={client_access}
      />
      <div className="pcoded-main-container flex-column-full">
        <div className={mainClass.join(' ')}>
          <div
            className="pcoded-content flex-column-full"
            style={{ padding: '0' }}
          >
            <div className="pcoded-inner-content flex-column-full">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )

  useEffect(() => {
    if (windowSize.width < 992) {
      let outSideClass = ['nav-outside']
      if (collapseMenu) {
        outSideClass = [...outSideClass, 'mob-backdrop']
      }
      if (headerFixedLayout) {
        outSideClass = [...outSideClass, 'mob-fixed']
      }
      common = (
        <div className={outSideClass.join(' ')} ref={ref}>
          {common}
        </div>
      )

      mainContainer = (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div className="pcoded-outside" onClick={() => mobileOutClickHandler}>
          {mainContainer}
        </div>
      )
    }
  }, [windowSize.width])

  let width = 0
  let initialDims

  window.addEventListener('scroll', () => {
    const firstCard = document.querySelector('.card:first-child ')
    const sticky_header = document.getElementById('fixed-nav')

    if (sticky_header) {
      if (!initialDims) {
        initialDims = sticky_header.getBoundingClientRect()

        sticky_header.style.top = `${initialDims.top}px`
        sticky_header.style.backgroundColor = '#FAF3F3'
        sticky_header.style.zIndex = '1000'
      }

      if (firstCard.getBoundingClientRect().bottom <= initialDims.bottom) {
        sticky_header.style.position = 'fixed'
        sticky_header.style.width = width
      } else {
        sticky_header.style.position = 'sticky'
        sticky_header.style.width = 'auto'
        width = getComputedStyle(sticky_header).width
      }
    }
  })

  return (
    <>
      {common}
      {mainContainer}
    </>
  )
}

export default AdminLayout

